import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const NAV = [
  { label: "Services", to: "/services" },
  { label: "Deadlines", to: "/#deadlines" },
  { label: "Trucking Insights", to: "/blog" },
  { label: "About Us", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export default function Header({ content }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const phone = content?.phone || "(380) 800-6365";
  const phoneHref = `tel:${phone.replace(/[^+\d]/g, "")}`;

  const goDeadlines = (e, to) => {
    if (to.includes("#")) {
      e.preventDefault();
      setOpen(false);
      const scroll = () => document.getElementById("deadlines")?.scrollIntoView({ behavior: "smooth" });
      if (location.pathname === "/") scroll();
      else { navigate("/"); setTimeout(scroll, 400); }
    } else setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-[#0B132B]/90 backdrop-blur-xl border-b border-[#1E293B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3 shrink-0">
            <span className="bg-white rounded-md p-1.5 inline-flex">
              <img src="/logo.png" alt="Crystal Logistics Services" className="h-8 lg:h-10 w-auto" />
            </span>
          </Link>
          <nav className="hidden lg:flex items-center gap-7" data-testid="desktop-nav">
            {NAV.map((item) => (
              <Link key={item.to} to={item.to} onClick={(e) => goDeadlines(e, item.to)}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm font-medium text-slate-300 hover:text-[#F97316] transition-colors duration-200">
                {item.label}
              </Link>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-4">
            <a href={phoneHref} data-testid="header-phone-link"
              className="flex items-center gap-2 text-sm font-semibold text-slate-200 hover:text-[#F97316] transition-colors">
              <Phone className="w-4 h-4 text-[#F97316]" /> {phone}
            </a>
            <Link to="/contact" data-testid="header-consultation-btn"
              className="bg-[#F97316] hover:bg-[#EA580C] text-[#0B132B] font-bold text-sm px-5 py-2.5 rounded-md transition-colors duration-200">
              Free Consultation
            </Link>
          </div>
          <button className="lg:hidden text-slate-200" data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#1E293B] bg-[#0B132B] px-4 py-4 space-y-1" data-testid="mobile-nav">
          {NAV.map((item) => (
            <Link key={item.to} to={item.to} onClick={(e) => goDeadlines(e, item.to)}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="block py-2.5 text-sm font-medium text-slate-300 hover:text-[#F97316]">
              {item.label}
            </Link>
          ))}
          <a href={phoneHref} data-testid="mobile-phone-link"
            className="flex items-center gap-2 py-2.5 text-sm font-semibold text-slate-200">
            <Phone className="w-4 h-4 text-[#F97316]" /> {phone}
          </a>
          <Link to="/contact" onClick={() => setOpen(false)} data-testid="mobile-consultation-btn"
            className="block text-center bg-[#F97316] hover:bg-[#EA580C] text-[#0B132B] font-bold text-sm px-5 py-3 rounded-md mt-2">
            Free Consultation
          </Link>
        </div>
      )}
    </header>
  );
}
